export default function LoadingScreen() {
  return (
    <div className="loading-screen" aria-hidden="true">
      <div className="loading-inner">
        <div className="loading-logo">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="ldg" x1="0" y1="0" x2="56" y2="56">
                <stop offset="0" stopColor="#00e5ff" />
                <stop offset=".5" stopColor="#a78bfa" />
                <stop offset="1" stopColor="#ff5ec4" />
              </linearGradient>
            </defs>
            <circle cx="28" cy="28" r="25" stroke="url(#ldg)" strokeWidth="1.6" opacity="0.5" />
            <path d="M10 10 L46 46 M46 10 L10 46" stroke="url(#ldg)" strokeWidth="2.4" strokeLinecap="round" />
            <circle cx="28" cy="28" r="4" fill="url(#ldg)" />
          </svg>
        </div>
        <div className="loading-name">Sutranode</div>
        <div className="loading-bar"><div className="loading-bar-fill"></div></div>
      </div>
    </div>
  );
}
